enum EVENTS_TEMPLATE_ID {
  EVENT = 'bf268cb0-dcaa-4e1a-9076-50d3bccc3bb7',
  FAIR = '64830a10-1b23-4bbb-94ec-53200c06b7a0',
  LIVE_EVENT = '6c2dd8ab-27c0-4cd8-9ef0-eb79607217f4',
}

const EVENT_TEMPLATE_ID_TYPE_QUERY_VALUE_MAP = {
  [EVENTS_TEMPLATE_ID.EVENT]: 'event',
  [EVENTS_TEMPLATE_ID.FAIR]: 'fair',
  [EVENTS_TEMPLATE_ID.LIVE_EVENT]: 'live-event',
};

const EVENT_TIMELINE_QUERY_VALUE_MAP = {
  UPCOMING: 'latest',
  ONGOING: 'latest',
  PAST: 'past',
};

enum EVENT_TITLE_DICTIONARY_KEY {
  EVENT = 'cnhi-events-type-event',
  FAIR = 'cnhi-events-type-fair',
  LIVE_EVENT = 'cnhi-events-type-live-event',
}

const EVENT_QUERY_STRINGS = {
  EVENT_TIMELINE: 'event-timeline',
  EVENT_TYPE: 'event-type',
  EVENT_PAGE: 'event-page',
};

const EVENTS_DATA_API_URL = '/apirequest/event-listing/get-events';

export {
  EVENTS_TEMPLATE_ID,
  EVENT_TITLE_DICTIONARY_KEY,
  EVENT_QUERY_STRINGS,
  EVENTS_DATA_API_URL,
  EVENT_TEMPLATE_ID_TYPE_QUERY_VALUE_MAP,
  EVENT_TIMELINE_QUERY_VALUE_MAP,
};
